import PropTypes from 'prop-types';
import _ from 'lodash';
import { useEffect, useState, useCallback } from 'react';
import { Stack, InputAdornment, TextField, MenuItem } from '@mui/material';
// components
import Iconify from '../../../../../components/Iconify';

// ----------------------------------------------------------------------

UserSupportCategoryTableToolbar.propTypes = {
  filterName: PropTypes.string,
  filterRole: PropTypes.string,
  onFilterName: PropTypes.func,
  onFilterRole: PropTypes.func,
  optionsRole: PropTypes.arrayOf(PropTypes.string),
};

let isRendered = false;
export default function UserSupportCategoryTableToolbar({
  filterName,
  filterRole,
  onFilterName,
  onFilterRole,
  optionsRole,
}) {
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (isRendered) {
      debouncedFilter(searchValue);
    }
    isRendered = true;
  }, [searchValue]);

  const debouncedFilter = useCallback(
    _.debounce((searchValue) => {
      onFilterName(searchValue);
    }, 500),
    []
  );

  return (
    <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} sx={{ py: 2.5, px: 3 }}>
      <TextField
        fullWidth
        value={searchValue}
        onChange={(event) => setSearchValue(event.target.value)}
        placeholder="Search ..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
}
